module.exports = __webpack_public_path__ + "static/round-lake-map-sites-8243c882ab20ca64ea41b5377cd2d2f9.jpg";